export enum AntibodyCreationStepKey {
  SELECT_FORMAT = 'SELECT_FORMAT',
  GET_VARIABLE_DOMAINS = 'GET_VARIABLE_DOMAINS',
  GET_CONSTANT_DOMAINS = 'GET_CONSTANT_DOMAINS',
  FINALIZE = 'FINALIZE',
}

export const ANTIBODY_CREATION_STEPS = [
  {key: AntibodyCreationStepKey.SELECT_FORMAT, title: 'Step 1', metadata: 'Decide antibody format'},
  {key: AntibodyCreationStepKey.GET_VARIABLE_DOMAINS, title: 'Step 2', metadata: 'Get variable domains'},
  {key: AntibodyCreationStepKey.GET_CONSTANT_DOMAINS, title: 'Step 3', metadata: 'Get constant domains'},
  {key: AntibodyCreationStepKey.FINALIZE, title: 'Step 4', metadata: 'Finalize and review'},
];

export interface SelectFormatPane {
  paneKey: AntibodyCreationStepKey.SELECT_FORMAT;
}

export interface GetVariableDomainsPane {
  paneKey: AntibodyCreationStepKey.GET_VARIABLE_DOMAINS;
}

export interface GetConstantDomainsPane {
  paneKey: AntibodyCreationStepKey.GET_CONSTANT_DOMAINS;
}

export interface FinalizePane {
  paneKey: AntibodyCreationStepKey.FINALIZE;
}

export type Pane = SelectFormatPane | GetVariableDomainsPane | GetConstantDomainsPane | FinalizePane;
